import React from "react";

function CostSummarySection() {
  return (
    <div className="project-view-summary-sec-main project-view-cost-summary-sec-main mt30">
      <div className="summary-title">
        <h3>Cost Summary</h3>
      </div>
      <div className="cost-summary-body">
        <div className="cost-summary-single-main">
          <p>PMS Connection</p>
          <span>$12.00</span>
        </div>
        <div className="cost-summary-single-main">
          <p>Database Connection</p>
          <span>$10.00</span>
        </div>
        <div className="cost-summary-single-main">
          <p>Business Intelligence</p>
          <span>$40.00</span>
        </div>
        <div className="cost-summary-single-main first-child">
          <p>Snapshot</p>
          <span>$16.00</span>
        </div>
        <div className="cost-summary-single-main second-child">
          <p>Annual Summary</p>
          <span>$7.00</span>
        </div>
        <div className="cost-summary-single-main second-child">
          <p>Forecast</p>
          <span>$9.00</span>
        </div>
        <div className="cost-summary-single-main first-child">
          <p>Day By Day</p>
          <span>$24.00</span>
        </div>
        <div className="cost-summary-single-main second-child">
          <p>Strategy</p>
          <span>$10.00</span>
        </div>
        <div className="cost-summary-single-main second-child">
          <p>Rate Plans</p>
          <span>$8.00</span>
        </div>
        <div className="cost-summary-single-main second-child">
          <p>Room Type</p>
          <span>$6.00</span>
        </div>
        <div className="cost-summary-single-main total-of-all">
          <p>Total</p>
          <span>$62.00</span>
        </div>
      </div>
    </div>
  );
}

export default CostSummarySection;
